import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit,
  EventEmitter, Output
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { BatchTagResolverService } from 'field-shared/batch-tag-resolver.service';

import { TagInfoFragment } from 'generated/graphql';
import { getTagTypeIcon } from 'field-shared/field-helper-functions';


/**
 * Used in conjuection iwth simple-query-tags2-list-item
 */
@Component({
  selector: 'app-tag-list-item',
  templateUrl: `./tag-list-item.component.html`,
  styleUrls: [`./tag-list-item.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagListItemComponent extends WithDisposableSubject() implements OnInit {
  @Input() tagId: string;

  @Output() tagRemoved = new EventEmitter<TagInfoFragment>();

  tag: TagInfoFragment;
  tagIcon: string;

  constructor(
    private _cd: ChangeDetectorRef,
    private _batchTagResolverService: BatchTagResolverService,
  ) {
    super();
  }

  ngOnInit(): void {
    this._batchTagResolverService.getTag(this.tagId).pipe(
      takeUntil(this.disposer)
    ).subscribe(result => {
      this.tagIcon = getTagTypeIcon(result.tagType);
      this.tag = result;
      this._cd.markForCheck();
    });
  }

  onRemoveTagClicked(tag: TagInfoFragment) {
    this.tagRemoved.emit(tag);
  }
}
